import React, { createContext, useState, useContext, useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import { api, apiAdmin } from '../service/api';
import { getParametersService } from '../service/serviceChat/parametersService';
import { getUserCompanyIdUser } from '../service/serviceChat/companyService';
import { putStatusUser } from '../service/serviceChat/userConfigService';
import { stopMonitoringStatusUser } from '../service/serviceChat/chatService';

const keyTokenStorage = '@UCB-Token';
const keyTokenReportsStorage = '@UCB-RP';
const keyIdUserStorage = '@UCB-IdUser';
const keyCompanyStorage = '@UCB-Company';
const keyStatusUserSystemStorage = '@UCB-StatusUserSystem';
const keyFunctionalityStorage = '@UCB-Functionality';
const keyUsernameStorage = '@UCB-Username';
const keyTutorialActiveStorage = '@UCB-TutorialActive';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [idUser, setIdUser] = useState(
    sessionStorage.getItem(keyIdUserStorage) || '',
  );
  const [token, setToken] = useState(
    sessionStorage.getItem(keyTokenStorage) || null,
  );
  const [tokenReports, setTokenReports] = useState(
    sessionStorage.getItem(keyTokenReportsStorage) || null,
  );
  const [company, setCompany] = useState(
    sessionStorage.getItem(keyCompanyStorage) || [],
  );
  const [functionality, setFunctionality] = useState(
    sessionStorage.getItem(keyFunctionalityStorage) || [],
  );
  const [statusUserSystem, setStatusUserSystem] = useState(
    sessionStorage.getItem(keyStatusUserSystemStorage) || '',
  );
  const [accessLevel, setAccessLevel] = useState([]);
  const [loadingAccessLevel, setLoadingAccessLevel] = useState(true);
  const [isTutorialActive, setIsTutorialActive] = useState(
    sessionStorage.getItem(keyTutorialActiveStorage) === 'true'
  );


  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  };

  if (tokenReports) {
    apiAdmin.defaults.headers.common['Authorization'] = `Bearer ${tokenReports}`;
  };

  const isAdm = useMemo(() => {
    return accessLevel?.includes('ADMINISTRADOR');
  }, [accessLevel]);

  let tokenError = 0;
  function onTokenError() {
    tokenError = tokenError + 1
    if (tokenError !== 1) return
    return window.location.href = '/?token_expired'
  }

  api.interceptors.response.use(
    (response) => {
      if (response?.data[1] === 401) {
        return onTokenError()
      }
      return response;
    }
  );

  function onSetToken(token) {
    setToken(token);
    sessionStorage.setItem(keyTokenStorage, token);
  };

  function onSetTokenReports(token) {
    setTokenReports(token);
    sessionStorage.setItem(keyTokenReportsStorage, token);
  };

  function onSetCompany(company) {
    setCompany(JSON.stringify(company));
    sessionStorage.setItem(keyCompanyStorage, JSON.stringify(company));
  };

  function onSetIdUser(id) {
    setIdUser(id);
    sessionStorage.setItem(keyIdUserStorage, id);
  };

  async function onfunctionality(refFunctionalitys) {
    let functionalitys = refFunctionalitys.map(
      (item, __) => { return item.tag }
    )
    setFunctionality(functionalitys);
    sessionStorage.setItem(keyFunctionalityStorage, functionalitys);
  };

  async function onSetStatusUserSystem(status) {
    setStatusUserSystem(status);
    sessionStorage.setItem(keyStatusUserSystemStorage, status);
  };

  async function firstAccess(username, password, companyID) {
    try {
      const {
        status,
        data: { access_token },
      } = await api.post('/login', {
        username: username,
        password: password,
        empresa_id: companyID,
      });
      if (status === 200) {
        setToken(access_token)
        return {
          error: false,
          isFirstAccess: true,
          companies: null,
        };
      } else {
        return {
          error: true,
          message: 'Usuário ou senha não está correto! Verifique !',
        };
      }
    } catch {
      return {
        error: true,
        message: 'Usuário ou senha não está correto! Verifique !',
      };
    }
  };

  async function authCompany(username, password, statusUser) {
    try {
      const {
        status,
        data: { empresas, user },
      } = await api.post('/auth-company', {
        username: username,
        password: password,
      });
      if (status === 200) {
        if (user?.primeiro_acesso === 'S') {
          setUser(user)
          return await firstAccess(username, password, empresas[0]?.id)
        } else {
          if (empresas?.length === 1) {
            return await signIn(
              username,
              password,
              empresas[0].id,
              0,
              statusUser
            );
          } else {
            return {
              error: false,
              isFirstAccess: false,
              companies: empresas,
              user: user
            }
          }
        }
      } else {
        return {
          error: true,
          message: 'Usuário ou senha não está correto! Verifique !',
        };
      }
    } catch {
      return {
        error: true,
        message: 'Usuário ou senha não está correto! Verifique !',
      };
    }
  };

  async function signIn(username, password, company_id, user_id, statusUser) {
    try {
      if (username && password) return signInByUsernamePassword(
        username,
        password,
        company_id,
        statusUser
      );
      return signInByToken(company_id, user_id, statusUser);
    } catch {
      const status = {
        error: true,
        message: 'Erro ao entrar ! tente novamente mais tarde',
      };
      return status;
    }
  };

  async function signInByUsernamePassword(
    username,
    password,
    company_id,
    statusUser
  ) {
    try {
      const {
        status,
        data: { access_token, empresa, user_id, funcionalidades, tutorial_status },
      } = await api.post('/login', {
        username: username,
        password: password,
        empresa_id: company_id,
      });
      if (status === 200) {
        onSetToken(access_token);
        onSetCompany(empresa);
        onSetIdUser(user_id);
        onfunctionality(funcionalidades);
        onSetTokenReports('');
        
        const hasTutorial = funcionalidades?.some(f => f.tag === 'tutorial');
        if (hasTutorial && (tutorial_status !== "finished" && tutorial_status !== "disabled")) {
          sessionStorage.setItem(keyTutorialActiveStorage, 'true');
          setIsTutorialActive(true);
          window.location.href = '/tutorial-first-access';
        } else {
          window.location.href = '/window';
        }

        const status = {
          error: false,
          message: 'NOT ERROR',
        };
        return status
      } else {
        const status = {
          error: true,
          message: 'Erro ao entrar ! tente novamente mais tarde',
        };
        return status;
      }
    } catch {
      const status = {
        error: true,
        message: 'Erro ao entrar ! tente novamente mais tarde',
      };
      return status;
    }
  };

  async function signInByToken(company_id, id_user, statusUser) {
    try {
      const {
        status,
        data: { access_token, empresa, user_id },
      } = await api.post('/company/auth', {
        user_id: id_user,
        company_id: company_id,
      });
      if (status === 200) {
        onSetToken(access_token);
        onSetCompany(empresa);
        onSetIdUser(user_id);
        onfunctionality(empresa.funcionalidades);
        onSetTokenReports('');
        
        const hasTutorial = empresa.funcionalidades?.some(f => f.tag === 'tutorial');
        if (hasTutorial && (empresa.tutorial_status !== "finished" && empresa.tutorial_status !== "disabled")) {
          sessionStorage.setItem(keyTutorialActiveStorage, 'true');
          setIsTutorialActive(true);
          window.location.href = '/tutorial-first-access';
        } else {
          window.location.href = '/window';
        }

        const status = {
          error: false,
          message: 'NOT ERROR',
        };
        return status
      } else {
        const status = {
          error: true,
          message: 'Erro ao entrar ! tente novamente mais tarde',
        };
        return status;
      }
    } catch {
      const status = {
        error: true,
        message: 'Erro ao entrar ! tente novamente mais tarde',
      };
      return status;
    }
  };

  async function searchUserLogged() {
    try {
      const {
        data: { data },
      } = await api.get('/user/' + idUser);
      return data;
    } catch (error) {
      return null;
    }
  };

  useEffect(() => {
    if (!idUser) return
    fetchData();
  }, [idUser]);
  async function fetchData() {
    try {
      setLoadingAccessLevel(true)
      await myAccessLevel();
      setLoadingAccessLevel(false)
    } catch (error) {
      // Trate o erro adequadamente aqui
      console.error(error);
    }
  };
  async function myAccessLevel() {
    const data = await getUserCompanyIdUser(idUser, IdCompany());

    setAccessLevel(data?.map((item, __) => item?.access_level_nome));
  };

  async function companiesUser() {
    try {
      const { data } = await api.get(`/company/auth?user_id=${idUser}`);
      return data;
    } catch {
      return null;
    }
  };

  async function onStatusOff() {
    try {
      return await putStatusUser('OFFLINE');
    } catch {
      return null;
    }
  };

  async function onSignInReports() {
    if (!accessLevel?.includes('RELATORIOS')) {
      sessionStorage.removeItem(keyTokenReportsStorage);
      setTokenReports(null);
      return
    }
    if (tokenReports) return
    try {
      const allResolved = await Promise.all([
        getParametersService('USUARIO_GRAFICOS'),
        getParametersService('SENHA_GRAFICOS'),
      ])
      if (allResolved[0] && allResolved[1]) {
        const { data: { result: { valor: username } } } = allResolved[0];
        const { data: { result: { valor: password } } } = allResolved[1];
        const { status, data: { access_token } } = await apiAdmin.post('/login',
          {
            username,
            password,
            empresa_id: JSON.parse(
              sessionStorage.getItem(keyCompanyStorage)
            ).id,
          }
        );
        if (status === 200) {
          onSetTokenReports(access_token)
        }
        else return toast.warn('Ops! Parece que você não tem acesso aos relatórios. ',
          { position: "top-center", theme: "colored" }
        );
      } else return toast.warn('Ops! Parece que você não tem acesso aos relatórios. ',
        { position: "top-center", theme: "colored" }
      );
    } catch {
      return toast.warn('Ops! Parece que você não tem acesso aos relatórios. ',
        { position: "top-center", theme: "colored" }
      );
    }
  };

  async function signOut() {
    try {
      if (token) {
        const { data } = await api.post('/logout');
        if (data.status_code !== 200) return;
        const stop = stopMonitoringStatusUser();
        if (!stop) return
      }
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = '/';
    } catch {
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = '/';
    };
  };


  function setTutorialActive() {
    sessionStorage.setItem(keyTutorialActiveStorage, 'true');
    setIsTutorialActive(true);
  }

  function setTutorialInactive() {
    sessionStorage.removeItem(keyTutorialActiveStorage);
    setIsTutorialActive(false);
  }

  const authValues = {
    user,
    idUser,
    company,
    company_id: IdCompany(),
    accessLevel,
    loadingAccessLevel,
    functionality,
    statusUserSystem,
    tokenReports,
    isAdm,
    isTutorialActive,
    setTutorialActive,
    setTutorialInactive,
    searchUserLogged,
    signIn,
    signOut,
    signInByToken,
    companiesUser,
    authCompany,
    onSetStatusUserSystem,
    onStatusOff,
    setFunctionality,
    onSignInReports
  };

  return (
    <AuthContext.Provider value={authValues}>
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth() {
  const context = useContext(AuthContext);
  return context;
}

export const Token = () => sessionStorage.getItem(keyTokenStorage);

export const TokenReports = () => sessionStorage.getItem(keyTokenReportsStorage);

export const CredentialsCompany = () => {
  const companyStorage = sessionStorage.getItem(keyCompanyStorage);
  return companyStorage ? JSON.parse(companyStorage)?.credentials_firebase : null;
};

export const PhoneCompany = () => {
  const companyStorage = sessionStorage.getItem(keyCompanyStorage);
  return companyStorage ? JSON.parse(companyStorage)?.wa_id : null;
};

export const IdCompany = () => {
  const companyStorage = sessionStorage.getItem(keyCompanyStorage);
  return companyStorage ? JSON.parse(companyStorage)?.id : null;
};

export const IdUser = () => sessionStorage.getItem(keyIdUserStorage);

export const StatusUser = () => sessionStorage.getItem(keyStatusUserSystemStorage);

export const GroupDefault = () => {
  const companyStorage = sessionStorage.getItem(keyCompanyStorage);
  return companyStorage ? JSON.parse(companyStorage)?.grupo_id_default : null;
};

export const Username = () => sessionStorage.getItem(keyUsernameStorage);

export const Functionality = () => sessionStorage.getItem(keyFunctionalityStorage);